import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = { class: "CrossSellCard__discount" }
const _hoisted_3 = {
  key: 0,
  class: "CrossSellCard__added"
}
const _hoisted_4 = { class: "CrossSellCard__body" }
const _hoisted_5 = {
  key: 0,
  class: "CrossSellCard__category"
}
const _hoisted_6 = { class: "CrossSellCard__price" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 1,
  class: "CrossSellCard__saving"
}
const _hoisted_10 = {
  key: 0,
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("path", { d: "M5 12h13M13 6l6 6-6 6" }, null, -1)
const _hoisted_12 = [
  _hoisted_11
]

import { computed } from 'vue';


export default {
  __name: 'SingleProductCrossSell',
  props: {
    item: {
        type: Object,
        required: true,
    },
    addedKeys: {
        type: Object,
        default: () => ({}),
    },
    badgeLabel: {
        type: String,
        default: '',
    },
},
  emits: ['open-product'],
  setup(__props, { emit }) {

const props = __props;





const variations = computed(() => (props.item.variations || []).filter((variation) => variation.in_stock));

const hasVariations = computed(() => variations.value.length > 0);
const previewVariation = computed(() => variations.value[0] || null);

const selectedImage = computed(() => previewVariation.value?.thumb || props.item.thumb);
const selectedPrice = computed(
    () => previewVariation.value?.discounted_price_html || props.item.discounted_price_html,
);
const selectedBasePrice = computed(() => previewVariation.value?.price_html || props.item.price_html);
const selectedSaving = computed(() => previewVariation.value?.saving_text || props.item.saving_text);

const isAdded = computed(() => !!props.addedKeys[`${props.item.id}:product`]);
const actionLabel = computed(() => {
    if (isAdded.value) return 'Dodano';
    return hasVariations.value ? 'Wybierz wariant' : 'Wybierz';
});

const openProduct = () => {
    emit('open-product', props.item);
};

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("article", {
    class: _normalizeClass(["CrossSellCard", { 'is-added': _unref(isAdded) }])
  }, [
    _createElementVNode("button", {
      type: "button",
      class: "Button--no-style CrossSellCard__image",
      onClick: openProduct
    }, [
      _createElementVNode("img", {
        src: _unref(selectedImage),
        alt: props.item.name
      }, null, 8, _hoisted_1),
      _createElementVNode("span", _hoisted_2, _toDisplayString(props.badgeLabel || `DRUGI PRODUKT -${props.item.discount_percent}%`), 1),
      (_unref(isAdded))
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Dodano"))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        type: "button",
        class: "Button--no-style CrossSellCard__title",
        onClick: openProduct
      }, _toDisplayString(props.item.name), 1),
      (props.item.category_names?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(props.item.category_names[0]), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", { innerHTML: _unref(selectedPrice) }, null, 8, _hoisted_7),
        _createElementVNode("del", { innerHTML: _unref(selectedBasePrice) }, null, 8, _hoisted_8)
      ]),
      (_unref(selectedSaving))
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Oszczędzasz " + _toDisplayString(_unref(selectedSaving)), 1))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        type: "button",
        class: "Button--no-style CrossSellCard__button",
        onClick: openProduct
      }, [
        _createTextVNode(_toDisplayString(_unref(actionLabel)) + " ", 1),
        (!_unref(isAdded))
          ? (_openBlock(), _createElementBlock("svg", _hoisted_10, _hoisted_12))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}
}

}